import * as React from 'react';
import { Dispatch } from 'redux';
import { ShopViewModel } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as ShopNormalizers from '../normalizers/shopNormalizers';

export class AddShopRequest extends BaseApiPostRequest<
  ShopViewModel,
  EntityNormalizers.NormalizedSingleEntity<ShopNormalizers.NormalizedShops>
> {
  constructor(formData: ShopViewModel, component: React.Component, dispatch: Dispatch) {
    super(formData, component, dispatch);
    this.path = `/shops`;
    this.normalizeMethod = ShopNormalizers.normalizeShop;
  }
}
